import { atom } from "jotai";

export const isPayNowCompletedAtom = atom<boolean>(false);